import { render, staticRenderFns } from "./KTCInstallmentPlanList.vue?vue&type=template&id=6058cab8&scoped=true&"
import script from "./KTCInstallmentPlanList.vue?vue&type=script&lang=js&"
export * from "./KTCInstallmentPlanList.vue?vue&type=script&lang=js&"
import style0 from "./KTCInstallmentPlanList.vue?vue&type=style&index=0&id=6058cab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6058cab8",
  null
  
)

export default component.exports